<div *ngIf="formData" class="se-stepper-sidenav__container">

    <div *ngFor="let key of objectKeys(formData)">
        <span *ngIf="formData[key] !== ''">
            <span #keys class="se-stepper-sidenav__key"
                  matTooltip="{{key | translate}}" positionAtOrigin="true" [matTooltipDisabled]="_isTooltipDisabled(keys)">
                {{ key | translate }}:
            </span>
            <span #value class="se-stepper-sidenav__value"
                  matTooltip="{{formData[key]}}" positionAtOrigin="true" [matTooltipDisabled]="_isTooltipDisabled(value)">
                {{ formData[key] }}
            </span>
        </span>
    </div>

</div>
